import React from 'react'
import { string, node } from 'prop-types'

function FilterPanel({ heading, description, children }) {
  return (
    <div className="filter-panel">
      <h2 className="cgt-legacy-heading-h5">{heading}</h2>
      <p className="cgt-legacy-text-default">{description}</p>
      {children}
    </div>
  )
}

FilterPanel.propTypes = {
  heading: string.isRequired,
  description: string.isRequired,
  children: node.isRequired,
}

FilterPanel.displayName = 'FilterPanel'

export default FilterPanel
